<template>
  <section class="seobox" dir="rtl">
    <header class="seobox__head">
      <div class="seobox__title">
        <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="2"/><path d="M20 20l-4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
        <h3>سئو و اسکیما</h3>
      </div>
      <span class="seobox__score" :class="'is-' + scoreLevel" :title="'امتیاز سئو: ' + score + ' از ۱۰۰'">{{ score }}<small>/100</small></span>
    </header>

    <nav class="seobox__tabs" role="tablist">
      <button v-for="t in tabs" :key="t.key" type="button" role="tab" :aria-selected="tab === t.key"
              :class="{ 'is-active': tab === t.key }" @click="tab = t.key">{{ t.label }}</button>
    </nav>

    <!-- general -->
    <div v-show="tab === 'general'" class="seobox__body">
      <div class="seobox__serp-head">
        <span class="seobox__label">پیش‌نمایش گوگل</span>
        <div class="seobox__seg">
          <button type="button" :class="{ 'is-active': device === 'desktop' }" @click="device = 'desktop'" title="دسکتاپ">
            <svg viewBox="0 0 24 24" width="16" height="16"><rect x="3" y="4" width="18" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="2"/><path d="M8 20h8M12 16v4" stroke="currentColor" stroke-width="2"/></svg>
          </button>
          <button type="button" :class="{ 'is-active': device === 'mobile' }" @click="device = 'mobile'" title="موبایل">
            <svg viewBox="0 0 24 24" width="16" height="16"><rect x="7" y="2" width="10" height="20" rx="2" fill="none" stroke="currentColor" stroke-width="2"/><path d="M11 18h2" stroke="currentColor" stroke-width="2"/></svg>
          </button>
        </div>
      </div>
      <div class="serp" :class="'serp--' + device">
        <div class="serp__site">
          <span class="serp__fav">{{ siteInitial }}</span>
          <div><div class="serp__name">{{ siteName }}</div><div class="serp__url" dir="ltr">{{ displayUrl }}</div></div>
        </div>
        <div class="serp__title">{{ truncPx(effectiveTitle, device === 'mobile' ? 500 : 580, '20px Arial') }}</div>
        <div class="serp__desc">{{ truncChars(effectiveDesc, device === 'mobile' ? 120 : 160) }}</div>
      </div>

      <label class="seobox__label">عنوان سئو</label>
      <input v-model="seo.seo_title" class="form-control" maxlength="255" :placeholder="name || 'عنوان صفحه'">
      <div class="seobox__meter"><span :class="'is-' + titleLevel" :style="{ width: Math.min(100, titlePx / 580 * 100) + '%' }"></span></div>
      <div class="seobox__count" :class="'is-' + titleLevel">{{ effectiveTitle.length }} کاراکتر / {{ titlePx }}px <small>(بهینه ۵۰ تا ۶۰ کاراکتر، حداکثر ۵۸۰px)</small></div>

      <label class="seobox__label">توضیحات متا</label>
      <textarea v-model="seo.meta_description" class="form-control" rows="3" maxlength="500" placeholder="توضیح کوتاه و جذاب صفحه برای نتایج جستجو"></textarea>
      <div class="seobox__meter"><span :class="'is-' + descLevel" :style="{ width: Math.min(100, effectiveDesc.length / 160 * 100) + '%' }"></span></div>
      <div class="seobox__count" :class="'is-' + descLevel">{{ effectiveDesc.length }} کاراکتر <small>(بهینه ۱۲۰ تا ۱۶۰)</small></div>

      <label class="seobox__label">کلمات کلیدی کانونی <small>(با کاما جدا کنید؛ اولی اصلی است)</small></label>
      <input v-model="seo.focus_keyword" class="form-control" maxlength="500" placeholder="مثال: میلگرد، میلگرد آجدار">
      <div v-if="keywords.length" class="seobox__chips">
        <span v-for="(k, i) in keywords" :key="k" :class="{ 'is-primary': i === 0 }">{{ k }}</span>
      </div>

      <ul class="seobox__checks">
        <li v-for="c in checks" :key="c.key" :class="'is-' + c.state">
          <svg v-if="c.state === 'good'" viewBox="0 0 24 24" width="16" height="16"><path d="M5 12l5 5 9-10" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>
          <svg v-else-if="c.state === 'warn'" viewBox="0 0 24 24" width="16" height="16"><path d="M12 7v6M12 17h.01" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>
          <svg v-else viewBox="0 0 24 24" width="16" height="16"><path d="M7 7l10 10M17 7L7 17" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>
          <span>{{ c.text }}</span>
        </li>
      </ul>
    </div>

    <!-- social -->
    <div v-show="tab === 'social'" class="seobox__body">
      <label class="seobox__label">عنوان شبکه‌های اجتماعی (OG / Twitter)</label>
      <input v-model="seo.og_title" class="form-control" maxlength="255" :placeholder="effectiveTitle">
      <label class="seobox__label">توضیحات شبکه‌های اجتماعی</label>
      <textarea v-model="seo.og_description" class="form-control" rows="2" maxlength="500" :placeholder="effectiveDesc"></textarea>
      <label class="seobox__label">آدرس تصویر اشتراک‌گذاری <small>(۱۲۰۰×۶۳۰ پیشنهادی)</small></label>
      <input v-model="seo.og_image" class="form-control" dir="ltr" maxlength="500" :placeholder="defaultImage || 'https://...'">
      <div class="og-card">
        <div class="og-card__img" :style="ogImg ? { backgroundImage: 'url(' + ogImg + ')' } : {}"><span v-if="!ogImg">بدون تصویر</span></div>
        <div class="og-card__body">
          <div class="og-card__host" dir="ltr">{{ host }}</div>
          <div class="og-card__title">{{ seo.og_title || effectiveTitle }}</div>
          <div class="og-card__desc">{{ truncChars(seo.og_description || effectiveDesc, 110) }}</div>
        </div>
      </div>
    </div>

    <!-- schema -->
    <div v-show="tab === 'schema'" class="seobox__body">
      <label class="seobox__label">نوع اسکیما</label>
      <SearchableSelect v-model="seo.schema_type" control-class="form-control" :options="schemaTypes" />
      <p class="seobox__hint">اسکیمای BreadcrumbList به‌صورت خودکار در سایت ساخته می‌شود.</p>

      <div v-if="isArticle" class="seobox__grid">
        <div><label class="seobox__label">تیتر</label><input v-model="sd.headline" class="form-control" :placeholder="effectiveTitle"></div>
        <div><label class="seobox__label">نویسنده</label><input v-model="sd.author" class="form-control"></div>
        <div><label class="seobox__label">نوع نویسنده</label>
          <select v-model="sd.author_type" class="form-control"><option value="Person">شخص</option><option value="Organization">سازمان</option></select></div>
        <div><label class="seobox__label">تاریخ انتشار</label><input v-model="sd.date_published" class="form-control" dir="ltr" placeholder="2026-10-16"></div>
      </div>

      <div v-if="seo.schema_type === 'Product'" class="seobox__grid">
        <div><label class="seobox__label">برند</label><input v-model="sd.brand" class="form-control" :placeholder="defaultBrand"></div>
        <div><label class="seobox__label">SKU</label><input v-model="sd.sku" class="form-control" dir="ltr" :placeholder="defaultSku"></div>
        <div><label class="seobox__label">GTIN / بارکد</label><input v-model="sd.gtin" class="form-control" dir="ltr"></div>
        <div><label class="seobox__label">MPN</label><input v-model="sd.mpn" class="form-control" dir="ltr"></div>
        <p class="seobox__hint seobox__full">قیمت (IRR) و موجودی به‌صورت خودکار از اطلاعات محصول خوانده می‌شود.</p>
      </div>

      <div v-if="seo.schema_type === 'FAQPage'">
        <div v-for="(f, i) in faq" :key="i" class="seobox__faq">
          <input v-model="f.q" class="form-control" placeholder="سؤال">
          <textarea v-model="f.a" class="form-control" rows="2" placeholder="پاسخ"></textarea>
          <button type="button" class="seobox__btn seobox__btn--danger" @click="faq.splice(i, 1)">حذف</button>
        </div>
        <button type="button" class="seobox__btn" @click="faq.push({ q: '', a: '' })">+ افزودن سؤال</button>
      </div>

      <div v-if="seo.schema_type === 'Organization' || seo.schema_type === 'LocalBusiness'" class="seobox__grid">
        <div><label class="seobox__label">نام</label><input v-model="sd.name" class="form-control" :placeholder="siteName"></div>
        <div><label class="seobox__label">تلفن</label><input v-model="sd.telephone" class="form-control" dir="ltr"></div>
        <div><label class="seobox__label">لوگو (URL)</label><input v-model="sd.logo" class="form-control" dir="ltr"></div>
        <div><label class="seobox__label">ایمیل</label><input v-model="sd.email" class="form-control" dir="ltr"></div>
        <template v-if="seo.schema_type === 'LocalBusiness'">
          <div><label class="seobox__label">شهر</label><input v-model="sd.city" class="form-control"></div>
          <div><label class="seobox__label">استان</label><input v-model="sd.region" class="form-control"></div>
          <div class="seobox__full"><label class="seobox__label">آدرس</label><input v-model="sd.street" class="form-control"></div>
          <div><label class="seobox__label">کد پستی</label><input v-model="sd.postal_code" class="form-control" dir="ltr"></div>
          <div><label class="seobox__label">ساعات کاری</label><input v-model="sd.opening_hours" class="form-control" dir="ltr" placeholder="Sa-Th 08:00-17:00"></div>
          <div><label class="seobox__label">عرض جغرافیایی</label><input v-model="sd.lat" class="form-control" dir="ltr"></div>
          <div><label class="seobox__label">طول جغرافیایی</label><input v-model="sd.lng" class="form-control" dir="ltr"></div>
          <div><label class="seobox__label">بازه قیمت</label><input v-model="sd.price_range" class="form-control" dir="ltr" placeholder="$$"></div>
        </template>
        <div class="seobox__full"><label class="seobox__label">شبکه‌های اجتماعی (هر خط یک آدرس)</label><textarea v-model="sd.same_as" class="form-control" dir="ltr" rows="2"></textarea></div>
      </div>

      <div v-if="seo.schema_type === 'HowTo'">
        <div class="seobox__grid">
          <div><label class="seobox__label">زمان کل (ISO 8601)</label><input v-model="sd.total_time" class="form-control" dir="ltr" placeholder="PT30M"></div>
          <div><label class="seobox__label">ابزار/مصالح (با کاما)</label><input v-model="sd.supply" class="form-control"></div>
        </div>
        <div v-for="(s, i) in steps" :key="'st' + i" class="seobox__faq">
          <input v-model="s.name" class="form-control" :placeholder="'عنوان گام ' + (i + 1)">
          <textarea v-model="s.text" class="form-control" rows="2" placeholder="توضیح گام"></textarea>
          <button type="button" class="seobox__btn seobox__btn--danger" @click="steps.splice(i, 1)">حذف</button>
        </div>
        <button type="button" class="seobox__btn" @click="steps.push({ name: '', text: '' })">+ افزودن گام</button>
      </div>

      <div v-if="seo.schema_type === 'Review'" class="seobox__grid">
        <div><label class="seobox__label">نام مورد بررسی</label><input v-model="sd.item_name" class="form-control" :placeholder="name || effectiveTitle"></div>
        <div><label class="seobox__label">نوع مورد</label>
          <select v-model="sd.item_type" class="form-control"><option value="Product">محصول</option><option value="Organization">سازمان</option><option value="LocalBusiness">کسب‌وکار</option><option value="CreativeWork">اثر</option></select></div>
        <div><label class="seobox__label">امتیاز (۱ تا ۵)</label><input v-model="sd.rating" type="number" min="1" max="5" step="0.5" class="form-control" dir="ltr"></div>
        <div><label class="seobox__label">نویسنده</label><input v-model="sd.author" class="form-control"></div>
      </div>

      <div v-if="seo.schema_type === 'VideoObject'" class="seobox__grid">
        <div class="seobox__full"><label class="seobox__label">آدرس ویدیو (contentUrl یا embedUrl)</label><input v-model="sd.content_url" class="form-control" dir="ltr"></div>
        <div><label class="seobox__label">تصویر کاور</label><input v-model="sd.thumbnail" class="form-control" dir="ltr" :placeholder="ogImg"></div>
        <div><label class="seobox__label">تاریخ بارگذاری</label><input v-model="sd.upload_date" class="form-control" dir="ltr" placeholder="2026-10-16"></div>
        <div><label class="seobox__label">مدت (ISO 8601)</label><input v-model="sd.duration" class="form-control" dir="ltr" placeholder="PT2M30S"></div>
      </div>
      <p v-if="schemaWarnings.length" class="seobox__hint is-bad">الزامات گوگل: {{ schemaWarnings.join('، ') }}</p>

      <label class="seobox__label">پیش‌نمایش JSON-LD</label>
      <pre class="seobox__json" dir="ltr">{{ jsonPreview }}</pre>
    </div>

    <!-- advanced -->
    <div v-show="tab === 'advanced'" class="seobox__body">
      <label class="seobox__label">آدرس کنونیکال</label>
      <input v-model="seo.canonical_url" class="form-control" dir="ltr" maxlength="500" :placeholder="fullUrl">
      <div class="seobox__switches">
        <label><input v-model="seo.robots_noindex" type="checkbox"> noindex <small>(عدم نمایش در نتایج)</small></label>
        <label><input v-model="seo.robots_nofollow" type="checkbox"> nofollow <small>(عدم دنبال‌کردن لینک‌ها)</small></label>
      </div>
      <p v-if="seo.robots_noindex" class="seobox__hint is-bad">این صفحه از نتایج گوگل حذف خواهد شد.</p>
    </div>
  </section>
</template>

<script>
import { siteBase as activeSiteBase, currentSite, getSiteId } from '@/utils/site'
import axios from "@/api/http";
const SCHEMA_TYPES = [
  { value: 'None', label: 'بدون اسکیما' },
  { value: 'Product', label: 'محصول (Product)' },
  { value: 'Article', label: 'مقاله (Article)' },
  { value: 'BlogPosting', label: 'پست وبلاگ (BlogPosting)' },
  { value: 'NewsArticle', label: 'خبر (NewsArticle)' },
  { value: 'WebPage', label: 'صفحه وب (WebPage)' },
  { value: 'AboutPage', label: 'درباره ما (AboutPage)' },
  { value: 'ContactPage', label: 'تماس با ما (ContactPage)' },
  { value: 'FAQPage', label: 'پرسش‌های متداول (FAQPage)' },
  { value: 'CollectionPage', label: 'صفحه مجموعه (CollectionPage)' },
  { value: 'Organization', label: 'سازمان (Organization)' },
  { value: 'LocalBusiness', label: 'کسب‌وکار محلی (LocalBusiness)' },
  { value: 'HowTo', label: 'آموزش گام‌به‌گام (HowTo)' },
  { value: 'Review', label: 'نقد و بررسی (Review)' },
  { value: 'VideoObject', label: 'ویدیو (VideoObject)' },
]

const empty = () => ({
  seo_title: '', meta_description: '', focus_keyword: '', canonical_url: '',
  robots_noindex: false, robots_nofollow: false, og_title: '', og_description: '', og_image: '',
  schema_type: 'None', schema_data: {},
})

const norm = (s) => String(s || '').replace(/[يى]/g, 'ی').replace(/ك/g, 'ک').replace(/\u200c/g, ' ').replace(/\s+/g, ' ').toLowerCase().trim()

let canvas = null
function textWidth(text, font) {
  try {
    canvas = canvas || document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    ctx.font = font
    return Math.round(ctx.measureText(text).width)
  } catch (e) {
    return Math.round(String(text).length * 9.5)
  }
}

export default {
  name: 'SeoBox',
  props: {
    entityType: { type: String, required: true },
    entityId: { type: [Number, String], default: 0 },
    name: { type: String, default: '' },
    slug: { type: String, default: '' },
    urlPrefix: { type: String, default: '/' },
    contentHtml: { type: String, default: '' },
    title: { type: String, default: undefined },
    description: { type: String, default: undefined },
    keyword: { type: String, default: undefined },
    defaultImage: { type: String, default: '' },
    defaultBrand: { type: String, default: '' },
    defaultSku: { type: String, default: '' },
    defaultSchema: { type: String, default: 'None' },
  },
  data() {
    return {
      tab: 'general',
      device: 'desktop',
      tabs: [
        { key: 'general', label: 'عمومی' },
        { key: 'social', label: 'شبکه‌های اجتماعی' },
        { key: 'schema', label: 'Schema / داده ساختاریافته' },
        { key: 'advanced', label: 'پیشرفته' },
      ],
      schemaTypes: SCHEMA_TYPES,
      steps: [],
      seo: { ...empty(), schema_type: this.defaultSchema },
      sd: {},
      faq: [],
      loading: false,
    }
  },
  computed: {
    siteUrl() { return activeSiteBase() || 'https://sakhtineo.com' },
    host() { try { return new URL(this.siteUrl).host } catch (e) { return 'sakhtineo.com' } },
    siteName() {
      try {
        return localStorage.getItem('site_name:' + getSiteId()) || currentSite().label || this.host
      } catch (e) {
        return currentSite().label || this.host
      }
    },
    siteInitial() { return (this.siteName || 'S').charAt(0) },
    fullUrl() { return this.siteUrl + this.urlPrefix + (this.slug || '') },
    displayUrl() {
      let p = this.urlPrefix + (this.slug || '')
      try { p = decodeURIComponent(p) } catch (e) { /* keep */ }
      return this.host + p.replace(/\/$/, '').split('/').filter(Boolean).map((x) => ' › ' + x).join('')
    },
    effectiveTitle() { return (this.seo.seo_title || this.name || '').trim() },
    effectiveDesc() { return (this.seo.meta_description || '').trim() },
    titlePx() { return textWidth(this.effectiveTitle, '20px Arial') },
    titleLevel() {
      const n = this.effectiveTitle.length
      if (!n) return 'bad'
      if (n >= 50 && n <= 60 && this.titlePx <= 580) return 'good'
      return n >= 30 && n <= 70 ? 'warn' : 'bad'
    },
    descLevel() {
      const n = this.effectiveDesc.length
      if (n >= 120 && n <= 160) return 'good'
      return n >= 70 && n <= 200 ? 'warn' : 'bad'
    },
    keywords() { return String(this.seo.focus_keyword || '').split(/[,،]/).map((s) => s.trim()).filter(Boolean).slice(0, 10) },
    kw() { return norm(this.keywords[0] || '') },
    doc() {
      try { return new DOMParser().parseFromString('<div>' + (this.contentHtml || '') + '</div>', 'text/html') } catch (e) { return null }
    },
    plain() { return this.doc ? norm(this.doc.body.textContent || '') : norm(String(this.contentHtml).replace(/<[^>]+>/g, ' ')) },
    words() { return this.plain ? this.plain.split(' ').filter(Boolean).length : 0 },
    firstPara() {
      if (!this.doc) return this.plain.slice(0, 400)
      const p = Array.from(this.doc.querySelectorAll('p')).find((x) => (x.textContent || '').trim())
      return norm(p ? p.textContent : this.plain.slice(0, 400))
    },
    images() { return this.doc ? Array.from(this.doc.querySelectorAll('img')) : [] },
    links() {
      if (!this.doc) return { internal: 0, external: 0 }
      let internal = 0
      let external = 0
      for (const a of this.doc.querySelectorAll('a[href]')) {
        const h = a.getAttribute('href') || ''
        if (/^(mailto|tel|#|javascript)/i.test(h)) continue
        if (/^https?:\/\//i.test(h)) { if (h.indexOf(this.host) !== -1) internal++; else external++ } else internal++
      }
      return { internal, external }
    },
    density() {
      if (!this.kw || !this.words) return 0
      const hay = ' ' + this.plain + ' '
      const count = hay.split(' ' + this.kw + ' ').length - 1 || (this.plain.split(this.kw).length - 1)
      const kwWords = this.kw.split(' ').length
      return Math.round((count * kwWords / this.words) * 1000) / 10
    },
    checks() {
      const kw = this.kw
      const t = norm(this.effectiveTitle)
      const d = norm(this.effectiveDesc)
      let slug = this.slug || ''
      try { slug = decodeURIComponent(slug) } catch (e) { /* keep */ }
      slug = norm(slug.replace(/[-_]/g, ' '))
      const st = (b, w = false) => (b ? 'good' : w ? 'warn' : 'bad')
      const list = [
        { key: 'kw', w: 0, state: st(!!kw), text: kw ? 'کلمه کلیدی کانونی تعیین شده است.' : 'کلمه کلیدی کانونی را وارد کنید.' },
        { key: 'tlen', w: 8, state: this.titleLevel, text: 'طول عنوان سئو: ' + this.effectiveTitle.length + ' کاراکتر (بهینه ۵۰ تا ۶۰).' },
        { key: 'dlen', w: 8, state: this.descLevel, text: 'طول توضیحات متا: ' + this.effectiveDesc.length + ' کاراکتر (بهینه ۱۲۰ تا ۱۶۰).' },
      ]
      if (kw) {
        list.push(
          { key: 'kt', w: 12, state: st(t.includes(kw)), text: t.includes(kw) ? 'کلمه کلیدی در عنوان سئو وجود دارد.' : 'کلمه کلیدی در عنوان سئو نیست.' },
          { key: 'kts', w: 6, state: st(t.startsWith(kw), t.includes(kw)), text: t.startsWith(kw) ? 'عنوان با کلمه کلیدی شروع می‌شود.' : 'بهتر است کلمه کلیدی در ابتدای عنوان باشد.' },
          { key: 'kd', w: 10, state: st(d.includes(kw)), text: d.includes(kw) ? 'کلمه کلیدی در توضیحات متا وجود دارد.' : 'کلمه کلیدی در توضیحات متا نیست.' },
          { key: 'ku', w: 8, state: st(slug.includes(kw) || slug.includes(kw.replace(/ /g, ''))), text: slug.includes(kw) ? 'کلمه کلیدی در آدرس (URL) وجود دارد.' : 'کلمه کلیدی در آدرس (URL) نیست.' },
          { key: 'kc', w: 8, state: st(this.plain.includes(kw)), text: this.plain.includes(kw) ? 'کلمه کلیدی در محتوا استفاده شده است.' : 'کلمه کلیدی در محتوا استفاده نشده است.' },
          { key: 'kp', w: 6, state: st(this.firstPara.includes(kw)), text: this.firstPara.includes(kw) ? 'کلمه کلیدی در پاراگراف اول آمده است.' : 'کلمه کلیدی را در پاراگراف اول بیاورید.' },
          { key: 'kden', w: 6, state: this.density >= 0.5 && this.density <= 2.5 ? 'good' : this.density > 0 ? 'warn' : 'bad', text: 'تراکم کلمه کلیدی: ' + this.density + '% (بهینه ۰٫۵ تا ۲٫۵).' },
          { key: 'kimg', w: 5, state: st(this.images.some((i) => norm(i.getAttribute('alt')).includes(kw)), this.images.length > 0), text: this.images.length ? 'متن جایگزین (alt) تصاویر شامل کلمه کلیدی باشد.' : 'تصویری با alt حاوی کلمه کلیدی به محتوا اضافه کنید.' },
        )
      }
      list.push(
        { key: 'len', w: 10, state: st(this.words >= 600, this.words >= 300), text: 'طول محتوا: ' + this.words + ' کلمه (پیشنهاد حداقل ۶۰۰).' },
        { key: 'alt', w: 3, state: st(this.images.length > 0 && this.images.every((i) => (i.getAttribute('alt') || '').trim()), this.images.length === 0), text: this.images.length ? 'همه تصاویر متن جایگزین (alt) داشته باشند.' : 'محتوا تصویری ندارد.' },
        { key: 'int', w: 5, state: st(this.links.internal > 0), text: 'لینک داخلی: ' + this.links.internal },
        { key: 'ext', w: 3, state: st(this.links.external > 0, true), text: 'لینک خارجی: ' + this.links.external },
        { key: 'ni', w: 2, state: st(!this.seo.robots_noindex), text: this.seo.robots_noindex ? 'صفحه noindex است.' : 'صفحه قابل ایندکس است.' },
      )
      return list
    },
    score() {
      const items = this.checks.filter((c) => c.w)
      const total = items.reduce((s, c) => s + c.w, 0) + (this.kw ? 0 : 54)
      const got = items.reduce((s, c) => s + (c.state === 'good' ? c.w : c.state === 'warn' ? c.w / 2 : 0), 0)
      return total ? Math.round(got / total * 100) : 0
    },
    scoreLevel() { return this.score >= 80 ? 'good' : this.score >= 50 ? 'warn' : 'bad' },
    isArticle() { return ['Article', 'BlogPosting', 'NewsArticle'].includes(this.seo.schema_type) },
    ogImg() { return this.seo.og_image || this.defaultImage },
    schemaData() {
      const out = {}
      Object.keys(this.sd).forEach((k) => { const v = this.sd[k]; if (v !== '' && v != null) out[k] = typeof v === 'string' ? v.trim() : v })
      const faq = this.faq.filter((f) => (f.q || '').trim() && (f.a || '').trim()).map((f) => ({ q: f.q.trim(), a: f.a.trim() }))
      if (this.seo.schema_type === 'FAQPage') out.faq = faq
      if (this.seo.schema_type === 'HowTo') out.steps = this.steps.filter((s) => (s.text || '').trim()).map((s) => ({ name: (s.name || '').trim(), text: s.text.trim() }))
      return out
    },
    schemaWarnings() {
      const t = this.seo.schema_type
      const d = this.schemaData
      const w = []
      if (t === 'FAQPage' && !(d.faq || []).length) w.push('حداقل یک سؤال و پاسخ')
      if (t === 'HowTo' && !(d.steps || []).length) w.push('حداقل یک گام')
      if (t === 'Review') { if (!d.rating) w.push('امتیاز'); if (!d.author) w.push('نویسنده') }
      if (t === 'VideoObject') { if (!(d.thumbnail || this.ogImg)) w.push('تصویر کاور'); if (!d.upload_date) w.push('تاریخ بارگذاری') }
      if (this.isArticle && !this.ogImg) w.push('تصویر مقاله')
      return w
    },
    jsonPreview() {
      const type = this.seo.schema_type
      if (!type || type === 'None') return '// اسکیما غیرفعال است (فقط BreadcrumbList)'
      const d = this.schemaData
      const node = { '@context': 'https://schema.org', '@type': type }
      const url = this.seo.canonical_url || this.fullUrl
      if (this.isArticle) {
        Object.assign(node, { headline: d.headline || this.effectiveTitle, description: this.effectiveDesc, mainEntityOfPage: url })
        if (d.author) node.author = { '@type': d.author_type || 'Person', name: d.author }
        if (d.date_published) node.datePublished = d.date_published
        if (this.ogImg) node.image = this.ogImg
      } else if (type === 'Product') {
        Object.assign(node, { name: this.name || this.effectiveTitle, description: this.effectiveDesc, sku: d.sku || this.defaultSku || undefined, gtin: d.gtin, mpn: d.mpn })
        if (d.brand || this.defaultBrand) node.brand = { '@type': 'Brand', name: d.brand || this.defaultBrand }
        if (this.ogImg) node.image = this.ogImg
        node.offers = { '@type': 'Offer', priceCurrency: 'IRR', price: '…', availability: 'https://schema.org/InStock', url }
      } else if (type === 'HowTo') {
        Object.assign(node, { name: this.effectiveTitle, description: this.effectiveDesc, totalTime: d.total_time, image: this.ogImg || undefined })
        if (d.supply) node.supply = String(d.supply).split(/[,،]/).map((x) => x.trim()).filter(Boolean).map((n) => ({ '@type': 'HowToSupply', name: n }))
        node.step = (d.steps || []).map((s, i) => ({ '@type': 'HowToStep', position: i + 1, name: s.name || undefined, text: s.text }))
      } else if (type === 'Review') {
        Object.assign(node, { name: this.effectiveTitle, itemReviewed: { '@type': d.item_type || 'Product', name: d.item_name || this.name || this.effectiveTitle },
          reviewRating: { '@type': 'Rating', ratingValue: d.rating || '…', bestRating: 5, worstRating: 1 }, author: { '@type': 'Person', name: d.author || '…' } })
      } else if (type === 'VideoObject') {
        Object.assign(node, { name: this.effectiveTitle, description: this.effectiveDesc, thumbnailUrl: d.thumbnail || this.ogImg, uploadDate: d.upload_date, duration: d.duration, contentUrl: d.content_url })
      } else if (type === 'FAQPage') {
        node.mainEntity = (d.faq || []).map((f) => ({ '@type': 'Question', name: f.q, acceptedAnswer: { '@type': 'Answer', text: f.a } }))
      } else if (type === 'Organization' || type === 'LocalBusiness') {
        Object.assign(node, { name: d.name || this.siteName, url: this.siteUrl, logo: d.logo, telephone: d.telephone, email: d.email })
        if (d.same_as) node.sameAs = String(d.same_as).split(/\s+/).filter(Boolean)
        if (type === 'LocalBusiness') {
          node.address = { '@type': 'PostalAddress', streetAddress: d.street, addressLocality: d.city, addressRegion: d.region, postalCode: d.postal_code, addressCountry: 'IR' }
          if (d.lat && d.lng) node.geo = { '@type': 'GeoCoordinates', latitude: d.lat, longitude: d.lng }
          node.openingHours = d.opening_hours
          node.priceRange = d.price_range
        }
      } else {
        Object.assign(node, { name: this.effectiveTitle, description: this.effectiveDesc, url })
      }
      return JSON.stringify(node, null, 2)
    },
  },
  watch: {
    entityId: { immediate: true, handler(v) { this.load(v) } },
    title: { immediate: true, handler(v) { if (v !== undefined && v !== null && v !== this.seo.seo_title) this.seo.seo_title = v } },
    description: { immediate: true, handler(v) { if (v !== undefined && v !== null && v !== this.seo.meta_description) this.seo.meta_description = v } },
    keyword: { immediate: true, handler(v) { if (v !== undefined && v !== null && v !== this.seo.focus_keyword) this.seo.focus_keyword = v } },
    'seo.seo_title'(v) { if (this.title !== undefined && v !== this.title) this.$emit('update:title', v) },
    'seo.meta_description'(v) { if (this.description !== undefined && v !== this.description) this.$emit('update:description', v) },
    'seo.focus_keyword'(v) { if (this.keyword !== undefined && v !== this.keyword) this.$emit('update:keyword', v) },
  },
  methods: {
    truncChars(s, n) { s = String(s || ''); return s.length > n ? s.slice(0, n - 1).trim() + '…' : s },
    truncPx(s, px, font) {
      s = String(s || '')
      if (textWidth(s, font) <= px) return s
      let lo = 0
      let hi = s.length
      while (lo < hi) { const mid = (lo + hi + 1) >> 1; if (textWidth(s.slice(0, mid) + '…', font) <= px) lo = mid; else hi = mid - 1 }
      return s.slice(0, lo).trim() + '…'
    },
    reset() {
      const keep = { seo_title: this.title || '', meta_description: this.description || '', focus_keyword: this.keyword || '' }
      this.seo = { ...empty(), schema_type: this.defaultSchema, ...keep }
      this.sd = {}
      this.faq = []
      this.steps = []
      this.tab = 'general'
    },
    load(id) {
      id = Number(id) || 0
      if (!id) { this.reset(); return }
      this.loading = true
      axios.post('/api/admin/seo/get', { entity_type: this.entityType, entity_id: id }, { show_pros: false }).then((res) => {
        const s = res.data && res.data.seo
        if (!s) { this.reset(); return }
        // legacy fields (title/description/keyword) owned by the parent form win when filled
        this.seo = {
          ...empty(),
          ...s,
          seo_title: this.title || s.seo_title || '',
          meta_description: this.description || s.meta_description || '',
          focus_keyword: this.keyword || s.focus_keyword || '',
          schema_type: s.schema_type || this.defaultSchema,
        }
        const d = { ...(s.schema_data || {}) }
        this.faq = Array.isArray(d.faq) ? d.faq.map((f) => ({ q: f.q || '', a: f.a || '' })) : []
        delete d.faq
        this.steps = Array.isArray(d.steps) ? d.steps.map((s) => ({ name: s.name || '', text: s.text || '' })) : []
        delete d.steps
        this.sd = d
      }).catch(() => {}).finally(() => { this.loading = false })
    },
    /** Persist SEO for the given entity id (call after the parent form saved successfully). */
    save(id) {
      id = Number(id) || Number(this.entityId) || 0
      if (!id) return Promise.resolve(null)
      const payload = {
        entity_type: this.entityType,
        entity_id: id,
        seo: { ...this.seo, schema_data: this.schemaData, score: this.score },
      }
      return axios.post('/api/admin/seo/save', payload, { show_pros: false }).then((res) => {
        if (res.data && res.data.error) this.$toast.open({ message: res.data.msg || 'خطا در ذخیره سئو', type: 'error', position: 'bottom-left' })
        return res.data
      }).catch(() => {
        this.$toast.open({ message: 'خطا در ذخیره تنظیمات سئو', type: 'error', position: 'bottom-left' })
        return null
      })
    },
  },
}
</script>

<style scoped lang="scss">
.seobox { background: var(--surface, #fff); border: 1px solid var(--border, #e5e7eb); border-radius: 12px; color: var(--text, #111827); overflow: hidden; }
.seobox__head { display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; border-bottom: 1px solid var(--border, #e5e7eb); }
.seobox__title { display: flex; align-items: center; gap: 8px; color: var(--accent, #2563eb); h3 { margin: 0; font-size: 15px; font-weight: 700; color: var(--text, #111827); } }
.seobox__score { min-width: 54px; text-align: center; padding: 4px 10px; border-radius: 999px; font-weight: 800; font-size: 15px; color: #fff;
  small { font-weight: 500; font-size: 10px; opacity: .85; }
  &.is-good { background: var(--success, #16a34a); } &.is-warn { background: var(--warning, #d97706); } &.is-bad { background: var(--danger, #dc2626); } }
.seobox__tabs { display: flex; gap: 4px; padding: 8px 12px 0; border-bottom: 1px solid var(--border, #e5e7eb); overflow-x: auto;
  button { border: 0; background: transparent; color: var(--muted, #6b7280); padding: 8px 12px; font-size: 13px; border-bottom: 2px solid transparent; cursor: pointer; white-space: nowrap; }
  button.is-active { color: var(--accent, #2563eb); border-bottom-color: var(--accent, #2563eb); font-weight: 700; } }
.seobox__body { padding: 14px 16px 16px; .form-control { border-radius: 8px; background: var(--input-bg, #fff); color: var(--text, #111827); border-color: var(--border-strong, #d1d5db); } }
.seobox__label { display: block; margin: 12px 0 6px; font-size: 12.5px; font-weight: 600; color: var(--text, #111827); small { color: var(--muted, #6b7280); font-weight: 400; } }
.seobox__hint { font-size: 12px; color: var(--muted, #6b7280); margin: 6px 0 0; &.is-bad { color: var(--danger, #dc2626); } }
.seobox__serp-head { display: flex; align-items: center; justify-content: space-between; }
.seobox__seg { display: inline-flex; border: 1px solid var(--border, #e5e7eb); border-radius: 8px; overflow: hidden;
  button { border: 0; background: transparent; color: var(--muted, #6b7280); padding: 4px 10px; cursor: pointer; display: flex; }
  button.is-active { background: var(--accent-soft, #eff6ff); color: var(--accent, #2563eb); } }
.serp { margin-top: 8px; padding: 14px 16px; border-radius: 10px; background: #fff; border: 1px solid var(--border, #e5e7eb); font-family: Arial, Tahoma, sans-serif; direction: rtl; }
.serp--desktop { max-width: 640px; } .serp--mobile { max-width: 380px; }
.serp__site { display: flex; align-items: center; gap: 8px; margin-bottom: 6px; }
.serp__fav { width: 26px; height: 26px; border-radius: 50%; background: #f1f3f4; color: #1a0dab; display: flex; align-items: center; justify-content: center; font-size: 13px; font-weight: 700; }
.serp__name { font-size: 14px; color: #202124; line-height: 1.2; } .serp__url { font-size: 12px; color: #4d5156; text-align: right; }
.serp__title { font-size: 20px; color: #1a0dab; line-height: 1.3; margin-bottom: 4px; } .serp--mobile .serp__title { font-size: 18px; }
.serp__desc { font-size: 14px; color: #4d5156; line-height: 1.58; }
.seobox__meter { height: 4px; border-radius: 4px; background: var(--surface-3, #f1f5f9); margin-top: 6px; overflow: hidden;
  span { display: block; height: 100%; transition: width .2s; } }
.is-good { --c: var(--success, #16a34a); } .is-warn { --c: var(--warning, #d97706); } .is-bad { --c: var(--danger, #dc2626); }
.seobox__meter span { background: var(--c); }
.seobox__count { font-size: 12px; margin-top: 4px; color: var(--c); small { color: var(--muted, #6b7280); } }
.seobox__chips { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px;
  span { font-size: 12px; padding: 2px 10px; border-radius: 999px; background: var(--surface-3, #f1f5f9); color: var(--text, #111827); }
  span.is-primary { background: var(--accent-soft, #eff6ff); color: var(--accent-text, #1d4ed8); font-weight: 700; } }
.seobox__checks { list-style: none; margin: 14px 0 0; padding: 0; display: grid; gap: 6px;
  li { display: flex; align-items: flex-start; gap: 8px; font-size: 13px; line-height: 1.6; }
  svg { flex: 0 0 auto; margin-top: 3px; color: var(--c); } }
.og-card { margin-top: 12px; max-width: 520px; border: 1px solid var(--border, #e5e7eb); border-radius: 10px; overflow: hidden; }
.og-card__img { height: 200px; background: var(--surface-3, #f1f5f9) center/cover no-repeat; display: flex; align-items: center; justify-content: center; color: var(--muted, #6b7280); font-size: 13px; }
.og-card__body { padding: 10px 12px; background: var(--surface-2, #f8fafc); }
.og-card__host { font-size: 11px; color: var(--muted, #6b7280); text-transform: uppercase; text-align: right; }
.og-card__title { font-weight: 700; font-size: 14px; margin: 2px 0; } .og-card__desc { font-size: 12.5px; color: var(--muted, #6b7280); }
.seobox__grid { display: grid; grid-template-columns: 1fr; gap: 0 12px; @media (min-width: 768px) { grid-template-columns: 1fr 1fr; } }
.seobox__full { grid-column: 1 / -1; }
.seobox__faq { display: grid; gap: 6px; padding: 10px; margin-top: 10px; border: 1px dashed var(--border-strong, #d1d5db); border-radius: 8px; }
.seobox__btn { margin-top: 10px; border: 1px solid var(--accent, #2563eb); color: var(--accent, #2563eb); background: transparent; border-radius: 8px; padding: 5px 12px; font-size: 13px; cursor: pointer; justify-self: start;
  &--danger { border-color: var(--danger, #dc2626); color: var(--danger, #dc2626); margin-top: 0; } }
.seobox__json { margin: 0; padding: 12px; max-height: 320px; overflow: auto; border-radius: 8px; background: var(--surface-3, #f1f5f9); color: var(--text, #111827); font-size: 12px; text-align: left; white-space: pre; }
.seobox__switches { display: flex; flex-wrap: wrap; gap: 20px; margin-top: 14px;
  label { display: flex; align-items: center; gap: 6px; font-size: 13px; cursor: pointer; margin: 0; } input { accent-color: var(--accent, #2563eb); } small { color: var(--muted, #6b7280); } }
</style>
